import { createSelector } from 'reselect';
import _get from 'lodash/get';

export const newBookingSelector = state => state.newBooking;

const deliveryIDFromProps = (_, props) => props.deliveryID;

const deliveryIDsFromProps = (_, props) => props.deliveryIDs;

export const firstDeliverySelector = state => {
  const firstDeliveryID = _get(state, ['newBooking', 'deliveryIDs', 0]);
  if (!firstDeliveryID) {
    return undefined;
  }
  return _get(state, ['newBooking', 'deliveryDetails', firstDeliveryID]);
};

export const deliveryDetailOverlaySelector = createSelector(
  newBookingSelector,
  nbs => nbs.detailOverlay,
);

export const bulkEditOverlaySelector = createSelector(
  newBookingSelector,
  nbs => nbs.bulkEditOverlay,
);

export const deliveryDetailOverlayVisibleSelector = createSelector(
  deliveryDetailOverlaySelector,
  overlay => _get(overlay, 'visible'),
);

export const deliverySelector = createSelector(
  newBookingSelector,
  deliveryIDFromProps,
  (nbs, deliveryID) => (deliveryID && nbs.deliveryDetails[deliveryID]) || null,
);

export const deliveryDetailSelector = createSelector(
  deliverySelector,
  delivery => (delivery && delivery.detail) || null,
);

export const allDeliveryIDsSelector = createSelector(
  newBookingSelector,
  nbs => nbs.deliveryIDs,
);

export const allDeliveriesSelector = createSelector(newBookingSelector, nbs =>
  nbs.deliveryIDs.map(
    deliveryID => (deliveryID && nbs.deliveryDetails[deliveryID]) || null,
  ),
);

export const deliveriesFromPropsSelector = createSelector(
  newBookingSelector,
  deliveryIDsFromProps,
  (nbs, deliveryIDs) =>
    deliveryIDs.map(
      deliveryID => (deliveryID && nbs.deliveryDetails[deliveryID]) || null,
    ),
);

export const creatingDeliveriesSelector = createSelector(
  newBookingSelector,
  nbs => _get(nbs, 'creatingDeliveries'),
);

export const creatingDeliveriesResultSelector = createSelector(
  newBookingSelector,
  nbs => _get(nbs, 'creatingDeliveriesResult'),
);

export const allDeliveriesMapSelector = createSelector(
  newBookingSelector,
  nbs => nbs.deliveryDetails,
);

export const recommendedVehicleTypeSelector = delivery => {
  const serviceType = _get(delivery, 'detail.configuration.serviceType');
  const serviceTypes = _get(delivery, 'config.serviceTypes', []);
  const specialServiceType = _get(
    delivery,
    'detail.configuration.specialServiceType',
  );

  if (serviceType && specialServiceType) {
    const st = serviceTypes.find(type => type.id === serviceType);
    const sst = _get(st, 'specialServices', []).find(
      specialType => specialType.id === specialServiceType,
    );
    return _get(sst, 'recommendedVehicleType');
  }

  return undefined;
};

export const prefillSenderInfoSelector = createSelector(
  newBookingSelector,
  nbs => nbs.prefillSenderInfo,
);

export const senderContactSelector = delivery =>
  _get(delivery, ['steps', [0], 'contact']);

export const rebookResultSelectorMaker = rebookJobID =>
  createSelector(newBookingSelector, nbs =>
    _get(nbs.rebookResults, rebookJobID),
  );

export const bookingConfigurationSelector = createSelector(
  newBookingSelector,
  nbs => _get(nbs, 'bookingConfiguration'),
);

export const bookingConfigurationParcelSizesSelector = createSelector(
  bookingConfigurationSelector,
  bookingConfiguration => _get(bookingConfiguration, 'parcelSizes', []),
);

export const isFetchingQuotesSelector = createSelector(
  newBookingSelector,
  nbs => _get(nbs, 'fetchingQuotes', false),
);
